module.exports = __webpack_public_path__ + "img/user.043c3c80.png";